var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1755329844077,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 5592,
    width: 32,
    height: 32,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M560 504v32c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-32c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8z",
    "p-id": 5593,
    fill: "#1f2937"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1024 504v409c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V504c0-4.4 3.6-8 8-8h384c4.4 0 8 3.6 8 8v40c0 35.3 28.7 64 64 64h96c35.3 0 64-28.7 64-64v-40c0-4.4 3.6-8 8-8h384c4.4 0 8 3.6 8 8zM896 177H744c-4.4 0-8-3.6-8-8v-25c0-53-43-96-96-96H384c-53 0-96 43-96 96v25c0 4.4-3.6 8-8 8H128C57.3 177 0 234.3 0 305v119c0 4.4 3.6 8 8 8h1008c4.4 0 8-3.6 8-8V305c0-70.7-57.3-128-128-128z m-544-33c0-17.7 14.3-32 32-32h256c17.7 0 32 14.3 32 32v24c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-24z",
    "p-id": 5594,
    fill: "#1f2937"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.8fe42bea.svg";
export { ForwardRef as ReactComponent };